import MaintenanceDetailMaterial from "./MaintenanceDetailMaterial";
export default MaintenanceDetailMaterial;
